import React from 'react';
import styles from './UnplannedMaintenancePage.module.scss';

interface UnplannedMaintenancePageProps {
	errorCode?: string;
	errorMessage?: string;
}

const UnplannedMaintenancePage: React.FC<UnplannedMaintenancePageProps> = ({
	errorCode,
	errorMessage,
}) => {
	return (
		<div className={styles.container}>
			<div className={styles.icon}>🛠️</div>
			<h1 className={styles.title}>Unplanned Maintenance</h1>
			<p className={styles.message}>
				Our site is currently undergoing unplanned maintenance. We apologize for
				the inconvenience and are working to resolve the issue as quickly as
				possible.
			</p>
			<p className={styles.suggestion}>
				Please try again later or contact support if the issue persists.
			</p>
		</div>
	);
};

export default UnplannedMaintenancePage;
